import { apiSlice } from '../api/apiSlice'
import { GroupVacationAcknowledgeRequestDTO, UpcomingVacationDTO } from '../../types/utils/VacationTypes'
import { BaseResponse } from '../../types/response/BaseResponse'

export const upcomingVacationApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getUpcomingVacations: builder.query<BaseResponse<UpcomingVacationDTO>, Record<string, any>>({
      query: params => ({
        url: 'vacation/upcoming',
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Vacation', id: 'UPCOMING_LIST' }],
    }),
    groupAcknowledgeVacations: builder.mutation<void, string[]>({
      query: vacationIds => ({
        url: 'vacation/acknowledgement/group',
        method: 'POST',
        body: { vacationIds } as GroupVacationAcknowledgeRequestDTO,
      }),
      invalidatesTags: [{ type: 'Vacation', id: 'UPCOMING_LIST' }, { type: 'VacationAcknowledgement' }],
    }),
  }),
})

export const { useGetUpcomingVacationsQuery, useGroupAcknowledgeVacationsMutation } = upcomingVacationApiSlice
